/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgSettings.css";
import "./OrgInfo.css";
import "./OrgBilling.css";
//import "./OrgReferral.css";
import "./OrgDocs.css";
import "./PaymentPageCustomization.css";
import "./OrgPassword.css";
import "./OrgPayMe.css";
// import "./OrgFPS.css";
import "./OrgBank.css";
import "./OrgPayout.css";
import "./OrgBalanceReports.css";
import "./OrgReceipt.css";
import "./OrgTerms.css";
import "./RenderCustomDomain.css";
import "./RenderCustomInputFields.css";

import "./RenderStripe.css";
import "./RenderPayPal.css";
import "./RenderPayMe.css";
import "./RenderTapAndGo.css";
import "./RenderAlipay.css";
import "./RenderWeChatPay.css";
import "./RenderBocPay.css";
import "./RenderOctopus.css";
import "./RenderFPS.css";
import "./RenderBankTransfer.css";
import "./RenderCheckWriting.css";
import "./RenderCash.css";
import "./RenderPaymentMethods.css";
import "./PaymentMethodCard.css";
import "./PaymentMethodModal.css";
import "./component/custom-domain-styles.css";
import "./UpgradeNoticeCard.css";

import { RenderOrgInfo } from "./component/RenderOrgInfo";
import RenderOrgBilling from "./component/RenderOrgBilling";
// import { RenderOrgReferral } from "./component/RenderOrgReferral";
import { RenderOrgDocs } from "./component/RenderOrgDocs";
import { RenderPaymentPageCustomization } from "./component/RenderPaymentPageCustomization";
import { RenderOrgPassword } from "./component/RenderOrgPassword";
import { RenderCustomDomain } from "./component/RenderCustomDomain";
import RenderCustomInputFields from "./component/RenderCustomInputFields";

import RenderStripe from "./component/RenderStripe.js";
// import { RenderPayPal } from "./component/RenderPayPal";
import RenderPayMe from "./component/RenderPayMe";
import { RenderAlipay } from "./component/RenderAlipay";
import { RenderWeChatPay } from "./component/RenderWeChatPay";
import { RenderOctopus } from "./component/RenderOctopus";
//import { RenderTapAndGo } from "./component/RenderTapAndGo";
import { RenderBocPay } from "./component/RenderBocPay";
import RenderFPS from "./component/RenderFPS";
import RenderBankTransfer from "./component/RenderBankTransfer";
import RenderCheckWriting from "./component/RenderCheckWriting";
import RenderCash from "./component/RenderCash";
import RenderPaymentMethods from "./component/RenderPaymentMethods";
import PaymentMethodPage from "./component/PaymentMethodPage";
import RenderOrgBalanceReports from "./component/RenderOrgBalanceReports";
import RenderOrgReceipt from "./component/RenderOrgReceipt";
import RenderOrgTerms from "./component/RenderOrgTerms";

import CollaborationSettings from "./CollaborationSettings";
import RevenueShareConfig from "../BusinessSettings/RevenueShareConfig";
import NonprofitLinker from "../BusinessSettings/NonprofitLinker";

import { simpleFetch } from "../../restWrapper";
import PropTypes from "prop-types";
import errorMsg from "../../assets/json/errMsg.json";

import { API_ENDPOINT, PHOTO_PATH, PLATFORM } from "../../config";
import { getDefaultReceiptTemplate, ensureRequiredElements } from "./component/receiptTemplateDefaults";

import { renderOrgLanguageSelector } from "../../assets/component/renderOrgLanguageSelector.js";

class OrgSettings extends Component {
  constructor(props) {
    super(props);

    // Bind methods
    this.onBackBtn = this.onBackBtn.bind(this);
    this.redirectToOrgBilling = this.redirectToOrgBilling.bind(this);
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);

    this.state = {
      p: "default", // Default to default
      organizationObj: [],
      bankAc: undefined, // undefined = loading, [] = loaded but empty
      stripeKyc: undefined, // undefined = loading, 0 = KYC complete, >0 = KYC pending
      balance: 0,
      username: "",
      payoutAmount: 0,
      language: this.props.language,
      paymentMethodsExpanded: false, // Track if payment methods dropdown is expanded
      generalExpanded: true, // Track if general dropdown is expanded (default to expanded)
      customizabilityExpanded: false, // Track if customizability dropdown is expanded
      paymentColorsExpanded: true, // Track if Payment Page Customization > Colors section is expanded
      paymentAmountsExpanded: true, // Track if Payment Page Customization > Choose Amount Presets section is expanded
      openColorPickerKey: null, // Which color field's picker (Hue/Twitter) is currently revealed, if any
      editingPresetAmountIndex: null, // Which preset donation amount index is being edited inline in the preview
      mobileMenuExpanded: false, // Track if mobile menu is expanded
      selectedPaymentMethod: null, // Track which payment method to auto-open in modal
      orgPw: {
        pw: "",
        newPw: "",
        reNewPw: "",
      },
      payme: {
        clientId: "",
        clientSecret: "",
        signingKeyId: "",
        signingKey: "",
        paymeTransactionFeePercentage: "",
      },
      fps: {
        merId: "",
        FPSClientId: "",
        FPSClientSecret: "",
      },
      flies: [],
      loading: false,
      errMsg: {
        oldPassword: {
          msg: "",
        },
        newPassword: {
          msg: "",
        },
        reNewPw: {
          msg: "",
        },
      },
      orgInfoHasErr: false,
      validateOrgInfo: false,
      errMsgInfo: {
        statementDescriptor: {
          msg: "",
        },
        organizationUrl: {
          msg: "",
        },
        submitErr: {
          msg: "",
        },
        username: {
          msg: "",
        },
        firstName: {
          msg: "",
        },
        lastName: {
          msg: "",
        },
        phoneNumber: {
          msg: "",
        },
        organizationName: {
          msg: "",
        },
        minimumPaymentAmount: {
          msg: "",
        },
        subDomain: {
          msg: "",
        },
        organizationAddress: {
          msg: "",
        },
        organizationIRDNo: {
          msg: "",
        },
        logo: {
          msg: "",
        },
        paymentCode: {
          method: "",
          msg: "",
          isCode: true,
        },
        customFields: {
          msg: "",
        },
      },
      errMsgPayout: {},
      submitedBool: {
        pw: false,
      },
      // Receipt template editor
      receiptTemplate: null,
      selectedElementId: null,
      receiptEditorDirty: false,
      receiptEditorOpen: false,
      activeReceiptType: PLATFORM === "plug" ? "payment" : "donation",
      previewDonorType: "individual",
    };

    this.onBackBtn = this.onBackBtn.bind(this);

    this.handleLogo = this.handleLogo.bind(this);
    this.handleUpdatePaymentData = this.handleUpdatePaymentData.bind(this);
    this.handleUploadPaymentCode = this.handleUploadPaymentCode.bind(this);
    this.handleUpdatePaymentStatus = this.handleUpdatePaymentStatus.bind(this);
    this.handleToggleEnableStripeLink = this.handleToggleEnableStripeLink.bind(this);

    this.handleUpdateCustomFields = this.handleUpdateCustomFields.bind(this);
    this.handleUpdateCustomFieldsStatus =
      this.handleUpdateCustomFieldsStatus.bind(this);

    this.handlePw = this.handleOrgPwInput.bind(this, "pw");
    this.handleNewPw = this.handleOrgPwInput.bind(this, "newPw");
    this.handleReNewPw = this.handleOrgPwInput.bind(this, "reNewPw");

    //PAYME
    this.handlePayMeClientId = this.handleOrgPayMeInput.bind(this, "clientId");

    this.handlePayMeClientSecret = this.handleOrgPayMeInput.bind(
      this,
      "clientSecret",
    );

    this.handlePayMeSigningKeyId = this.handleOrgPayMeInput.bind(
      this,
      "signingKeyId",
    );

    this.handlePayMeSigningKey = this.handleOrgPayMeInput.bind(
      this,
      "signingKey",
    );

    this.handlePayMeTransactionFee = this.handleOrgPayMeInput.bind(
      this,
      "paymeTransactionFeePercentage",
    );

    // FPS
    // this.handleMerId = this.handleOrgFPSInput.bind(this, "merId");
    // this.handleFPSClientId = this.handleOrgFPSInput.bind(this, "FPSClientId");
    // this.handleFPSClientSecret = this.handleOrgFPSInput.bind(
    //  this,
    //  "FPSClientSecret"
    // );

    this.redirectToOrgBilling = this.redirectToOrgBilling.bind(this);

    this.handleSd = this.handleOrgInput.bind(this, "statementDescriptor");
    this.handleUrl = this.handleOrgInput.bind(this, "organizationUrl");
    this.handleMinAmount = this.handleOrgInput.bind(
      this,
      "minimumPaymentAmount",
    );

    this.handleOrganizationName = this.handleOrgInput.bind(
      this,
      "organizationName",
    );
    this.handleSubDomain = this.handleOrgInput.bind(this, "subDomain");
    this.handleUsername = this.handleUsername.bind(this);
    this.handleLastName = this.handleOrgDataInput.bind(this, "lastName");
    this.handleFirstName = this.handleOrgDataInput.bind(this, "firstName");
    this.handlePhoneNumber = this.handleOrgDataInput.bind(this, "phoneNumber");

    this.submitBtnClick = this.submitBtnClick.bind(this);
    this.submitPwBtnClick = this.submitPwBtnClick.bind(this);

    this.handleOrgHeaderColor = this.handleOrgColor.bind(this, "headerColor");
    this.handleOrgButtonColor = this.handleOrgColor.bind(this, "buttonColor");
    this.handleOrgBarColor = this.handleOrgColor.bind(this, "progressBarColor");

    this.handleToggleAutoReceipt = this.handleToggleAutoReceipt.bind(this);
    this.handlePreviewDonorTypeChange = this.handlePreviewDonorTypeChange.bind(this);

    // Receipt template editor handlers
    this.handleReceiptElementDrag = this.handleReceiptElementDrag.bind(this);
    this.handleReceiptElementResize = this.handleReceiptElementResize.bind(this);
    this.handleAddReceiptText = this.handleAddReceiptText.bind(this);
    this.handleAddReceiptImage = this.handleAddReceiptImage.bind(this);
    this.handleUploadReceiptLogo = this.handleUploadReceiptLogo.bind(this);
    this.handleUploadReceiptBackground = this.handleUploadReceiptBackground.bind(this);
    this.handleReceiptBackgroundOpacity = this.handleReceiptBackgroundOpacity.bind(this);
    this.handleRemoveReceiptBackground = this.handleRemoveReceiptBackground.bind(this);
    this.handleDeleteReceiptElement = this.handleDeleteReceiptElement.bind(this);
    this.handleUpdateReceiptElement = this.handleUpdateReceiptElement.bind(this);
    this.handleReorderReceiptElements = this.handleReorderReceiptElements.bind(this);
    this.handleSaveReceiptTemplate = this.handleSaveReceiptTemplate.bind(this);
    this.handleSelectReceiptElement = this.handleSelectReceiptElement.bind(this);
    this.handleResetReceiptTemplate = this.handleResetReceiptTemplate.bind(this);
    this.handleSendTestReceipt = this.handleSendTestReceipt.bind(this);
    this.handleReceiptNumberConfigChange = this.handleReceiptNumberConfigChange.bind(this);
    this.handleReceiptPageSizeChange = this.handleReceiptPageSizeChange.bind(this);
    this.handleReceiptOrientationChange = this.handleReceiptOrientationChange.bind(this);
  }

  loadOrganizationData() {
    simpleFetch("/organizations", "GET", {}).then((res) => {
      let orgObj = res.body.organizationObj;


      if (!orgObj.organizationIRDNo) orgObj.organizationIRDNo = "";
      if (!orgObj.organizationAddress) orgObj.organizationAddress = "";
      
      // Ensure domain object exists
      if (!orgObj.domain) {
        orgObj.domain = {
          domain: "",
          tokens: [],
          email: "",
          emailDomain: ""
        };
      }

      // Get the organization type
      const organizationType = orgObj.organizationType || "nonprofit";

      this.setState(
        {
          orgID: res.body._id, // Use MongoDB ObjectId, not numeric id
          username: res.body.username,
          organizationObj: res.body.organizationObj,
          firstName: res.body.firstName,
          lastName: res.body.lastName,
          phoneNumber: res.body.phoneNumber,
          loading: false,
          currentPlan: res.body.currentPlan,
          cards: [], // Initialize empty cards array
          subscriptions: [], // Initialize empty subscriptions array
          receiptTemplate: ensureRequiredElements(orgObj.receiptTemplate || getDefaultReceiptTemplate()),
          receiptEditorDirty: false,
        },
        () => {
          // Now that we have the organization type, fetch the balance and other data

          // Get billing information
          simpleFetch("/organizations/billing", "GET", {}).then((res) => {
            if (res.status === 200) {
              this.setState({
                billing: res.body.url,
              });
            }
          });

          // Get receipt counter (next receipt numbers)
          simpleFetch("/organizations/payments/receipt-counter", "GET").then((res) => {
            if (res.status === 200) {
              this.setState({ receiptCounter: res.body });
            }
          });

          // Get bank list
          this.getBankList();

          // Get Stripe KYC status
          this.getStripeKyc();

          // Get balance with organization type
          simpleFetch(
            `/organizations/balance`,
            "GET",
            {},
          ).then((res) => {
            if (res.status !== 200) return false;

            // Calculate total balance from all available and pending amounts
            let totalAvailable = 0;
            let totalPending = 0;

            // Sum up all available amounts
            if (res.body.available && Array.isArray(res.body.available)) {
              totalAvailable = res.body.available.reduce(
                (sum, amount) => sum + (amount || 0),
                0,
              );
            }

            // Sum up all pending amounts
            if (res.body.pending && Array.isArray(res.body.pending)) {
              totalPending = res.body.pending.reduce(
                (sum, amount) => sum + (amount || 0),
                0,
              );
            }

            const balance = totalAvailable + totalPending;
            const floorBalance = Math.floor(balance * 100) / 100;


            this.setState({
              balance: floorBalance,
            });
          });
        },
      );
    });
  }


  componentDidMount() {
    let page = 0;
    if (this.props.location.page) {
      page = this.props.location.page;
    }
    this.setState({
      page: page,
      loading: true,
    }, () => {
      // Callback ensures loading state is set before loading org data (React 18 fix)
      this.loadOrganizationData();
    });
  }

  getBankList() {
    simpleFetch("/organizations/banks", "GET").then((res) => {
      if (res.status !== 200) {
        // console.log("Error fetching bank list:", JSON.stringify(res));
        // Set to empty array on error so it's no longer "loading"
        this.setState({ bankAc: [] });
        return false;
      }
      // Check if res.body.data exists (matching the structure in RenderStripe.js)
      if (res.body.data && res.body.data.length > 0) {
        this.setState({
          bankAc: res.body.data,
        });
      } else if (res.body && res.body.length > 0) {
        // Fallback to the original approach if data property doesn't exist
        this.setState({
          bankAc: res.body,
        });
      } else {
        // No bank accounts found
        this.setState({ bankAc: [] });
      }
    }).catch(err => {
      // console.error("Failed to fetch bank list:", err);
      this.setState({ bankAc: [] });
    });
  }

  getStripeKyc() {
    simpleFetch("/organizations/StripeKYCStatus", "GET").then((res) => {
      if (res.status !== 200) {
        // Set to 0 on error (assume no KYC issues if can't fetch)
        this.setState({ stripeKyc: 0 });
        return;
      }

      let kycCount = 0;
      if (res.body.requirements) {
        const currentlyDue = res.body.requirements.currently_due?.length || 0;
        const eventuallyDue = res.body.requirements.eventually_due?.length || 0;
        const pastDue = res.body.requirements.past_due?.length || 0;
        kycCount = currentlyDue + eventuallyDue + pastDue;
      }

      this.setState({ stripeKyc: kycCount });
    }).catch(err => {
      // console.error("Failed to fetch Stripe KYC status:", err);
      this.setState({ stripeKyc: 0 });
    });
  }

  onBackBtn() {
    this.props.history.push({ pathname: "/AccountOverview" });
  }

  togglePaymentMethods() {
    const isExpanding = !this.state.paymentMethodsExpanded;
    this.setState({
      paymentMethodsExpanded: isExpanding,
      generalExpanded: false,
      customizabilityExpanded: false,
      // Set page to payment methods (6) when expanding
      page: isExpanding ? 6 : this.state.page,
    });
  }

  toggleGeneral() {
    const isExpanding = !this.state.generalExpanded;
    this.setState({
      generalExpanded: isExpanding,
      paymentMethodsExpanded: false,
      customizabilityExpanded: false,
      // Set page to first general item (0) when expanding
      page: isExpanding ? 0 : this.state.page,
    });
  }

  toggleCustomizability() {
    const isExpanding = !this.state.customizabilityExpanded;
    this.setState({
      customizabilityExpanded: isExpanding,
      generalExpanded: false,
      paymentMethodsExpanded: false,
      // Set page to first customizability item (7) when expanding
      page: isExpanding ? 7 : this.state.page,
    });
  }

  toggleMobileMenu() {
    this.setState({
      mobileMenuExpanded: !this.state.mobileMenuExpanded,
    });
  }

  clickChangePage(p) {
    // If clicking on the General category header (we'll use index -2 for this)
    if (p === -2) {
      this.toggleGeneral();
      return;
    }

    // If clicking on the Customizability category header (we'll use index -3 for this)
    if (p === -3) {
      this.toggleCustomizability();
      return;
    }

    // If clicking on the Payment Methods category header (we'll use index -4 for this)
    // This navigates to the consolidated page AND toggles the dropdown
    if (p === -4) {
      this.setState({
        page: 6,
        paymentMethodsExpanded: !this.state.paymentMethodsExpanded,
        generalExpanded: false,
        customizabilityExpanded: false,
        selectedPaymentMethod: null,
        mobileMenuExpanded: false,
      });
      return;
    }

    // Payment method sub-indices (100-111) - navigate directly to that page
    const paymentMethodIndices = [100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111];

    if (paymentMethodIndices.includes(p)) {
      this.setState({
        page: p,
        paymentMethodsExpanded: true,
        mobileMenuExpanded: false,
      });
      return;
    }

    if (this.state.page === 3) {
      this.setState({
        ...this.state,
        orgPw: {
          pw: "",
          newPw: "",
          reNewPw: "",
        },
      });
    }

    // Define indices for dropdown categories
    const generalIndices = [0, 1, 2, 3, 4, 5];
    // Payment Methods is now a single page at index 6 (no dropdown needed)
    const customizabilityIndices = [7, 8, 9, 10];

    // Auto-expand the appropriate dropdown when a menu item is selected
    if (generalIndices.includes(p) && !this.state.generalExpanded) {
      this.setState({
        page: p,
        generalExpanded: true,
        mobileMenuExpanded: false,
        selectedPaymentMethod: null,
      });
    } else if (
      customizabilityIndices.includes(p) &&
      !this.state.customizabilityExpanded
    ) {
      this.setState({
        page: p,
        customizabilityExpanded: true,
        mobileMenuExpanded: false,
        selectedPaymentMethod: null,
      });
    } else if (p === 6) {
      // Clicking "All Payment Methods" - go to page 6 without auto-opening a modal
      this.setState({
        page: p,
        paymentMethodsExpanded: true,
        mobileMenuExpanded: false,
        selectedPaymentMethod: null,
      });
    } else if (p === 11 || p === 12) {
      // Clicking Revenue Sharing or Collaboration - collapse other sections
      this.setState({
        page: p,
        generalExpanded: false,
        customizabilityExpanded: false,
        paymentMethodsExpanded: false,
        mobileMenuExpanded: false,
        selectedPaymentMethod: null,
      });
    } else {
      this.setState({
        page: p,
        mobileMenuExpanded: false,
        selectedPaymentMethod: null,
      });
    }
  }

  redirectToOrgBilling() {
    this.setState({ page: 1 }, () => {
      // Any follow-up action that depends on the state update
    });
  }

  setOrgInfoData(s, name) {
    const updatedErrData = { ...this.state.errMsgInfo };
    if (
      name !== "headerColor" &&
      name !== "buttonColor" &&
      name !== "progressBarColor"
    ) {
      // Check if errData[name] exists before trying to set msg
      if (updatedErrData[name]) {
        updatedErrData[name] = { ...updatedErrData[name], msg: "" };
      }
    }

    // console.log("setOrgInfoData called:", { name, value: s });

    this.setState({
      orgInfoHasErr: false,
      organizationObj: {
        ...this.state.organizationObj,
        [name]: s,
      },
      errMsgInfo: updatedErrData,
    }, () => {
      // console.log("setState completed for", name, "- new value:", this.state.organizationObj[name]);
    });
  }

  handleLogo(e) {
    if (this.state.loading) return false;
    var file = e.target.files[0];
    var err = errorMsg[this.state.language].orgInfoErr.logoErr;
    var errData = this.state.errMsgInfo;
    if (file.type === "image/png" || file.type === "image/jpeg") {
      this.setState({
        loading: true,
      });
      let data = new FormData();
      data.append("file", file);

      fetch(API_ENDPOINT + "/organizations/s3", {
        credentials: "include",
        method: "POST",
        body: data,
      }).then((res) => {
        if (res.status !== 200) {
          errData.logo.msg = errorMsg[this.state.language].fail;
          this.setState({
            errMsgInfo: errData,
            loading: false,
          });
          return false;
        }
        res
          .json()
          .then((body) => {
            const url = PHOTO_PATH + body.id;
            this.setState({
              loading: false,
              orgInfoHasErr: false,
              organizationObj: {
                ...this.state.organizationObj,
                logo: url,
              },
            });
          })
          .catch(() => {
            errData.logo.msg = errorMsg[this.state.language].fail;
            this.setState({
              loading: false,
            });
          });
      });
    } else {
      errData.logo.msg = err;
      this.setState({
        errMsgInfo: errData,
      });
    }
  }

  handleUpdateCustomFields(formData) {
    if (this.state.loading) return false;

    const errData = this.state.errMsgInfo;

    this.setState({
      loading: true,
    });

    const reqBody = {
      language: this.state.language,
      forms: {
        rows: formData,
      },
    };

    simpleFetch("/organizations/formfields/update", "POST", reqBody).then(
      (response) => {
        if (response.status !== 200) {
          errData.customFields = {
            msg: "Failed to update custom fields",
          };

          this.setState({
            errMsgInfo: errData,
            loading: false,
          });

          return false;
        }

        const oldData = this.state.organizationObj.formSetting || {};

        const newData = {
          enabled: response.body.enabled || false,
          rows: response.body.rows || [],
        };

        this.setState({
          loading: false,
          organizationObj: {
            ...this.state.organizationObj,
            formSetting: {
              ...oldData,
              ...newData,
            },
          },
        });
      },
    );
  }

  handleUpdateCustomFieldsStatus(e) {
    if (this.state.loading) return false;

    const newStatus = e.target.checked;

    const errData = this.state.errMsgInfo;

    this.setState({
      loading: true,
    });

    simpleFetch(`/organizations/formfields/toggle/${newStatus}`, "POST").then(
      (response) => {
        if (response.status !== 200) {
          errData.customFields = {
            msg: "Failed to update custom field status",
          };

          this.setState({
            errMsgInfo: errData,
            loading: false,
          });

          return false;
        }

        const oldData = this.state.organizationObj.formSetting || {};

        const newData = {
          enabled: response.body.enabled || false,
          rows: response.body.rows || [],
        };

        this.setState({
          loading: false,
          organizationObj: {
            ...this.state.organizationObj,
            formSetting: {
              ...oldData,
              ...newData,
            },
          },
        });
      },
    );
  }

  handleUpdatePaymentData(paymentMethodKey, paymentMethodLabel, data) {
    if (this.state.loading) return false;

    const errData = this.state.errMsgInfo;

    this.setState({
      loading: true,
    });

    let formData = new FormData();
    formData.append("paymentMethod", paymentMethodKey);
    formData.append("paymentMethodLabel", paymentMethodLabel);

    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    const requestOptions = {
      credentials: "include",
      method: "POST",
      body: formData,
    };

    // Returned so the chain is awaitable. Callers are event handlers and
    // ignore it; the tests cannot observe the rejection path without it.
    return fetch(
      API_ENDPOINT + "/organizations/payments/payment-code-upload",
      requestOptions,
    )
      .then((response) => {
        if (response.status !== 200) {
          errData.paymentCode = {
            method: paymentMethodKey,
            msg: "Failed to update payment data",
            isCode: false,
          };

          this.setState({
            errMsgInfo: errData,
            loading: false,
          });

          return false;
        }

        response
          .json()
          .then((body) => {
            const newData = {};

            Object.entries(body.data).forEach(([key, value]) => {
              const stripKey = key.replace(
                `organizationObj.paymentMethodCode.${paymentMethodKey}.`,
                "",
              );

              newData[stripKey] = value;
            });

            const oldData =
              this.state.organizationObj.paymentMethodCode &&
              this.state.organizationObj.paymentMethodCode[paymentMethodKey]
                ? this.state.organizationObj.paymentMethodCode[paymentMethodKey]
                : {};

            this.setState({
              loading: false,
              organizationObj: {
                ...this.state.organizationObj,
                paymentMethodCode: {
                  ...(this.state.organizationObj.paymentMethodCode || {}),
                  [paymentMethodKey]: {
                    ...oldData,
                    ...newData,
                  },
                },
              },
            });
          })
          .catch((error) => {
            errData.paymentCode = {
              method: paymentMethodKey,
              msg: "Failed to update payment data",
              isCode: false,
            };

            this.setState({
              errMsgInfo: errData,
              loading: false,
            });
          });
      })
      // Raw fetch rejects when the request never lands — offline, DNS, CORS —
      // and that is not the same path as a non-200 response, so the inner
      // catch above never sees it. Without this the rejection is unhandled and
      // `loading` stays true; since the method opens with
      // `if (this.state.loading) return false`, that takes the save out of
      // service until the page is reloaded. Mirrors the non-200 branch so a
      // dead network reads the same as a rejected save.
      .catch(() => {
        errData.paymentCode = {
          method: paymentMethodKey,
          msg: "Failed to update payment data",
          isCode: false,
        };

        this.setState({
          errMsgInfo: errData,
          loading: false,
        });
      });
  }

  handleUploadPaymentCode(e) {
    if (this.state.loading) return false;

    const paymentCode = e.target.files[0];
    const paymentMethod = e.target.dataset.method;
    const paymentMethodLabel = e.target.dataset.label;

    const err = "Please upload the payment code image. (.png / .jpg)";
    const errData = this.state.errMsgInfo;

    if (paymentCode.type === "image/png" || paymentCode.type === "image/jpeg") {
      this.setState({
        loading: true,
      });

      let formData = new FormData();
      formData.append("paymentCode", paymentCode);
      formData.append("paymentMethod", paymentMethod);
      formData.append("paymentMethodLabel", paymentMethodLabel);

      const requestOptions = {
        credentials: "include",
        method: "POST",
        body: formData,
      };

      // Returned for the same reason as handleUpdatePaymentData above.
      return fetch(
        API_ENDPOINT + "/organizations/payments/payment-code-upload",
        requestOptions,
      )
        .then((response) => {
          if (response.status !== 200) {
            errData.paymentCode = {
              method: paymentMethod,
              msg: "Failed to upload payment code",
            };

            this.setState({
              errMsgInfo: errData,
              loading: false,
            });

            return false;
          }

          response
            .json()
            .then((body) => {
              const newData = {};

              Object.entries(body.data).forEach(([key, value]) => {
                const stripKey = key.replace(
                  `organizationObj.paymentMethodCode.${paymentMethod}.`,
                  "",
                );

                newData[stripKey] = value;
              });

              const oldData =
                this.state.organizationObj.paymentMethodCode &&
                this.state.organizationObj.paymentMethodCode[paymentMethod]
                  ? this.state.organizationObj.paymentMethodCode[paymentMethod]
                  : {};

              this.setState({
                loading: false,
                organizationObj: {
                  ...this.state.organizationObj,
                  paymentMethodCode: {
                    ...(this.state.organizationObj.paymentMethodCode || {}),
                    [paymentMethod]: {
                      ...oldData,
                      ...newData,
                    },
                  },
                },
              });
            })
            .catch(() => {
              errData.paymentCode = {
                method: paymentMethod,
                msg: "Failed to upload payment code",
              };

              this.setState({
                errMsgInfo: errData,
                loading: false,
              });
            });
        })
        // Same rejection path as handleUpdatePaymentData: a request that never
        // lands would otherwise leave `loading` true and lock the upload out.
        .catch(() => {
          errData.paymentCode = {
            method: paymentMethod,
            msg: "Failed to upload payment code",
          };

          this.setState({
            errMsgInfo: errData,
            loading: false,
          });
        });
    } else {
      errData.paymentCode = {
        method: paymentMethod,
        msg: err,
      };
      this.setState({
        errMsgInfo: errData,
      });
    }
  }

  handleUpdatePaymentStatus(e, paymentMethod) {
    if (this.state.loading) return false;

    const newStatus = e.target.checked;

    const errData = this.state.errMsgInfo;

    this.setState({
      loading: true,
    });

    simpleFetch("/organizations/payments/toggle-payment", "POST", {
      paymentMethod,
      paymentMethodStatus: newStatus,
    }).then((response) => {
      if (response.status !== 200) {
        errData.paymentCode = {
          method: paymentMethod,
          msg: "Failed to update payment status",
          isCode: false,
        };

        this.setState({
          errMsgInfo: errData,
          loading: false,
        });

        return false;
      }

      const newData = {};

      Object.entries(response.body.data).forEach(([key, value]) => {
        const stripKey = key.replace(
          `organizationObj.paymentMethodCode.${paymentMethod}.`,
          "",
        );

        newData[stripKey] = value;
      });

      const oldData =
        this.state.organizationObj.paymentMethodCode &&
        this.state.organizationObj.paymentMethodCode[paymentMethod]
          ? this.state.organizationObj.paymentMethodCode[paymentMethod]
          : {};

      this.setState({
        loading: false,
        organizationObj: {
          ...this.state.organizationObj,
          paymentMethodCode: {
            ...(this.state.organizationObj.paymentMethodCode || {}),
            [paymentMethod]: {
              ...oldData,
              ...newData,
            },
          },
        },
      });
    });
  }

  handleToggleEnableStripeLink(e) {
    if (this.state.loading) return false;

    const newStatus = e.target.checked;

    this.setState({ loading: true });

    simpleFetch("/organizations", "PUT", {
      enableStripeLink: newStatus,
    }).then((response) => {
      if (response.status !== 200) {
        this.setState({ loading: false });
        return false;
      }

      this.setState({
        loading: false,
        organizationObj: {
          ...this.state.organizationObj,
          enableStripeLink: newStatus,
        },
      });
    });
  }

  handlePreviewDonorTypeChange(type) {
    this.setState({ previewDonorType: type });
  }

  handleToggleAutoReceipt(e) {
    if (this.state.loading) return false;

    const newStatus = e.target.checked;

    this.setState({ loading: true });

    simpleFetch("/organizations", "PUT", {
      autoReceipt: newStatus,
    }).then((response) => {
      if (response.status !== 200) {
        this.setState({ loading: false });
        return false;
      }

      this.setState({
        loading: false,
        organizationObj: {
          ...this.state.organizationObj,
          autoReceipt: newStatus,
        },
      });
    });
  }

  handleReceiptPageSizeChange(size) {
    if (this.state.loading) return;

    this.setState({ loading: true });

    simpleFetch("/organizations", "PUT", {
      receiptPageSize: size,
    }).then((response) => {
      if (response.status !== 200) {
        this.setState({ loading: false });
        return;
      }

      this.setState({
        loading: false,
        organizationObj: {
          ...this.state.organizationObj,
          receiptPageSize: size,
        },
      });
    });
  }

  handleReceiptOrientationChange(orientation) {
    if (this.state.loading) return;

    this.setState({ loading: true });

    simpleFetch("/organizations", "PUT", {
      receiptOrientation: orientation,
    }).then((response) => {
      if (response.status !== 200) {
        this.setState({ loading: false });
        return;
      }

      this.setState({
        loading: false,
        organizationObj: {
          ...this.state.organizationObj,
          receiptOrientation: orientation,
        },
      });
    });
  }

  // ── Receipt Template Editor Handlers ──

  handleSelectReceiptElement(id) {
    this.setState({ selectedElementId: id });
  }

  handleReceiptElementDrag(id, x, y) {
    const template = { ...this.state.receiptTemplate };
    template.elements = template.elements.map((el) =>
      el.id === id ? { ...el, x: Math.round(x), y: Math.round(y) } : el
    );
    this.setState({ receiptTemplate: template, receiptEditorDirty: true });
  }

  handleReceiptElementResize(id, width, height, x, y) {
    const template = { ...this.state.receiptTemplate };
    template.elements = template.elements.map((el) =>
      el.id === id
        ? { ...el, width: Math.round(width), height: Math.round(height), x: Math.round(x), y: Math.round(y) }
        : el
    );
    this.setState({ receiptTemplate: template, receiptEditorDirty: true });
  }

  handleAddReceiptText() {
    const template = { ...this.state.receiptTemplate };
    const newEl = {
      id: "custom-text-" + Date.now(),
      type: "custom-text",
      x: 150,
      y: 300,
      width: 150,
      height: 40,
      content: "New Text",
      style: { fontSize: 12, fontWeight: "normal", color: "#000000", textAlign: "left" }
    };
    template.elements = [...template.elements, newEl];
    this.setState({
      receiptTemplate: template,
      selectedElementId: newEl.id,
      receiptEditorDirty: true
    });
  }

  handleAddReceiptImage(file) {
    if (this.state.loading) return false;
    if (file.type !== "image/png" && file.type !== "image/jpeg") return false;

    this.setState({ loading: true });
    let data = new FormData();
    data.append("file", file);

    fetch(API_ENDPOINT + "/organizations/s3/receipt-media", {
      credentials: "include",
      method: "POST",
      body: data,
    })
      .then((res) => {
        if (res.status !== 200) {
          this.setState({ loading: false });
          return;
        }
        return res.json();
      })
      .then((body) => {
        if (!body) return;
        // Store the S3 key; frontend uses proxy endpoint, backend uses SDK directly
        const url = API_ENDPOINT + "/organizations/s3/receipt-media/" + body.id;
        const template = { ...this.state.receiptTemplate };
        const newEl = {
          id: "custom-image-" + Date.now(),
          type: "custom-image",
          x: 150,
          y: 300,
          width: 120,
          height: 80,
          src: url
        };
        template.elements = [...template.elements, newEl];
        this.setState({
          loading: false,
          receiptTemplate: template,
          selectedElementId: newEl.id,
          receiptEditorDirty: true
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  handleUploadReceiptLogo(file) {
    if (this.state.loading) return false;
    if (file.type !== "image/png" && file.type !== "image/jpeg") return false;

    this.setState({ loading: true });
    let data = new FormData();
    data.append("file", file);

    fetch(API_ENDPOINT + "/organizations/s3/receipt-media", {
      credentials: "include",
      method: "POST",
      body: data,
    })
      .then((res) => {
        if (res.status !== 200) {
          this.setState({ loading: false });
          return;
        }
        return res.json();
      })
      .then((body) => {
        if (!body) return;
        const url = API_ENDPOINT + "/organizations/s3/receipt-media/" + body.id;
        this.handleUpdateReceiptElement("header", { receiptLogo: url });
        this.setState({ loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  handleUploadReceiptBackground(file) {
    if (this.state.loading) return false;
    if (file.type !== "image/png" && file.type !== "image/jpeg") return false;

    this.setState({ loading: true });
    let data = new FormData();
    data.append("file", file);

    fetch(API_ENDPOINT + "/organizations/s3/receipt-media", {
      credentials: "include",
      method: "POST",
      body: data,
    })
      .then((res) => {
        if (res.status !== 200) {
          this.setState({ loading: false });
          return;
        }
        return res.json();
      })
      .then((body) => {
        if (!body) return;
        const url = API_ENDPOINT + "/organizations/s3/receipt-media/" + body.id;
        const template = { ...this.state.receiptTemplate };
        const prevOpacity = template.background ? template.background.opacity : 1;
        template.background = { src: url, opacity: prevOpacity };
        this.setState({
          loading: false,
          receiptTemplate: template,
          receiptEditorDirty: true
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  handleReceiptBackgroundOpacity(value) {
    const template = { ...this.state.receiptTemplate };
    if (!template.background) return;
    template.background = { ...template.background, opacity: value };
    this.setState({ receiptTemplate: template, receiptEditorDirty: true });
  }

  handleRemoveReceiptBackground() {
    const template = { ...this.state.receiptTemplate };
    delete template.background;
    this.setState({ receiptTemplate: template, receiptEditorDirty: true });
  }

  handleDeleteReceiptElement(id) {
    const template = { ...this.state.receiptTemplate };
    template.elements = template.elements.filter((el) => el.id !== id);
    this.setState({
      receiptTemplate: template,
      selectedElementId: null,
      receiptEditorDirty: true
    });
  }

  handleUpdateReceiptElement(id, updates) {
    const template = { ...this.state.receiptTemplate };
    template.elements = template.elements.map((el) =>
      el.id === id ? { ...el, ...updates } : el
    );
    this.setState({ receiptTemplate: template, receiptEditorDirty: true });
  }

  handleReorderReceiptElements(newElements) {
    const template = { ...this.state.receiptTemplate, elements: newElements };
    this.setState({ receiptTemplate: template, receiptEditorDirty: true });
  }

  handleSaveReceiptTemplate() {
    if (this.state.loading) return false;
    this.setState({ loading: true });

    simpleFetch("/organizations", "PUT", {
      receiptTemplate: this.state.receiptTemplate,
    }).then((response) => {
      if (response.status !== 200) {
        this.setState({ loading: false });
        return false;
      }
      this.setState({
        loading: false,
        receiptEditorDirty: false,
        organizationObj: {
          ...this.state.organizationObj,
          receiptTemplate: this.state.receiptTemplate,
        },
      });
    });
  }

  handleResetReceiptTemplate() {
    const defaultTemplate = getDefaultReceiptTemplate();
    this.setState({
      receiptTemplate: defaultTemplate,
      selectedElementId: null,
      receiptEditorDirty: true
    });
  }

  handleSendTestReceipt() {
    if (this.state.loading) return false;
    this.setState({ loading: true });

    simpleFetch("/organizations/payments/receipts/test", "POST", {
      receiptType: this.state.activeReceiptType || "donation",
    }).then((response) => {
      this.setState({ loading: false });
      if (response.status === 200) {
        alert("Test receipt sent to your email.");
      } else {
        alert("Failed to send test receipt. Please try again.");
      }
    });
  }

  handleReceiptNumberConfigChange(newConfig) {
    // Extract starting numbers and save format config without them
    const formatConfig = {};
    const counterUpdates = {};

    ["donation", "payment"].forEach((type) => {
      if (newConfig[type]) {
        const { startingNumber, ...rest } = newConfig[type];
        formatConfig[type] = rest;
        if (startingNumber) {
          counterUpdates[type] = startingNumber;
        }
      }
    });

    this.setState({
      organizationObj: {
        ...this.state.organizationObj,
        receiptNumberConfig: formatConfig
      }
    });

    simpleFetch("/organizations", "PUT", {
      receiptNumberConfig: formatConfig
    });

    // Update counters if starting numbers were set
    if (Object.keys(counterUpdates).length > 0) {
      simpleFetch("/organizations/payments/receipt-counter", "POST", counterUpdates).then(() => {
        // Refresh the counter so the preview shows the updated next number
        simpleFetch("/organizations/payments/receipt-counter", "GET").then((res) => {
          if (res.status === 200) {
            this.setState({ receiptCounter: res.body });
          }
        });
      });
    }
  }

  handleOrgPwInput(name, e) {
    this.setState({
      orgPw: {
        ...this.state.orgPw,
        [name]: e.target.value,
      },
      submitedBool: {
        ...this.state.submitedBool,
        pw: false,
      },
    });
  }

  handleOrgPayMeInput(name, e) {
    this.setState({
      payme: {
        ...this.state.payme,
        [name]: e.target.value,
      },
      submitedBool: {
        ...this.state.submitedBool,
        pw: false,
      },
    });
  }

  handleOrgFPSInput(name, e) {
    this.setState({
      fps: {
        ...this.state.fps,
        [name]: e.target.value,
      },
      submitedBool: {
        ...this.state.submitedBool,
        pw: false,
      },
    });
  }

  submitPwBtnClick() {
    let data = this.state.orgPw;
    let errJson = errorMsg[this.state.language].pwErr;
    let err = this.state.errMsg;
    if (
      data.pw === "" ||
      data.newPw === "" ||
      data.reNewPw === "" ||
      data.pw.length < 8 ||
      data.newPw < 8 ||
      data.reNewPw < 8
    ) {
      err.oldPassword.msg =
        data.pw === "" || data.pw.length < 8 ? errJson.passwdErr : "";
      err.newPassword.msg =
        data.newPw === "" || data.newPw < 8 ? errJson.passwdErr : "";
      err.reNewPw.msg =
        data.reNewPw === "" || data.reNewPw < 8 ? errJson.passwdErr : "";
      this.setState({ errMsg: err });
    } else {
      err.oldPassword.msg = "";
      err.newPassword.msg = data.pw === data.newPw ? errJson.newPasswdErr : "";
      err.reNewPw.msg = data.newPw !== data.reNewPw ? errJson.reEnterPwErr : "";

      if (
        err.newPassword.msg === "" &&
        err.reNewPw.msg === "" &&
        err.oldPassword.msg === ""
      ) {
        this.setState({
          errMsg: err,
          loading: true,
        });
        simpleFetch("/organizations/changepassword", "PUT", {
          oldPassword: data.pw,
          newPassword: data.newPw,
        }).then((res) => {
          switch (res.status) {
            case 422:
              err.oldPassword.msg = errJson.passwdErr;
              break;
            case 204:
              var boolObj = this.state.submitedBool;
              boolObj.pw = true;
              this.setState({
                submitedBool: boolObj,
              });
              break;
            default:
              break;
          }
          this.setState({
            errMsg: err,
            loading: false,
          });
        });
      } else {
        this.setState({
          errMsg: err,
        });
      }
    }
  }

  handleOrgInput(name, e) {
    const text = e.target.value;
    let letters = "";
    switch (name) {
      case "statementDescriptor":
      case "subDomain":
        if (text.length > 22) return false;
        letters = /^[a-zA-Z0-9\s]+$/;
        if (!text.match(letters)) {
          if (text !== "") return false;
        }
        break;
      default:
    }

    this.setOrgInfoData(e.target.value, name);
  }

  handleOrgDataInput(name, e) {
    this.setState({
      orgInfoHasErr: false,
      [name]: e.target.value,
    });
  }

  // New method to update multiple organizationObj fields at once
  setMultipleOrgInfoData(updates) {
    // console.log("setMultipleOrgInfoData called:", updates);

    this.setState({
      orgInfoHasErr: false,
      organizationObj: {
        ...this.state.organizationObj,
        ...updates,
      },
    }, () => {
      // console.log("setState completed - new organizationObj:", this.state.organizationObj);
    });
  }

  submitBtnClick() {
    this.setState({
      edited: false,
    });
  }

  handleOrgColor(name, color) {
    this.setOrgInfoData(color["hex"].substring(1), name);
  }

  handleUsername(e) {
    let errData = this.state.errMsgInfo;
    errData.username.msg = "";
    this.setState({
      username: e,
      errMsgInfo: errData,
    });
  }

  // organizationObj starts as [] and becomes an object once the fetch lands,
  // and [] is truthy — so a plain existence check cannot tell "not loaded"
  // from "loaded". Nonprofit-only surfaces must not render against the
  // placeholder: they would read the wrong listing state and snapshot it
  // (CP-300).
  orgLoaded() {
    return (
      !!this.state.organizationObj && !Array.isArray(this.state.organizationObj)
    );
  }

  renderSettingContent() {
    const p = this.state.page;
    const languageObj = this.props.languageObj;
    const renderTextContentObj = [
      languageObj.OrgInfo,         // 0: Organization Info
      languageObj.OrgBilling,      // 1: Billing
      languageObj.OrgReports,      // 2: Reports
      languageObj.OrgDocs,         // 3: Legal Documents
      languageObj.OrgPassword,     // 4: Change Password
      languageObj.OrgTerms,        // 5: Terms and Conditions
      languageObj.PaymentMethods,  // 6: Payment Methods (consolidated)
      languageObj.PaymentPageCustomization, // 7: Payment Page Customization
      languageObj.CustomDomain,    // 8: Custom Domain
      languageObj.CustomFields,    // 9: Custom Input Fields
      languageObj.OrgReceipt,      // 10: Receipt Management
    ];
    switch (p) {
      case 0: // General (OrgInfo)
        return (
          <div>{RenderOrgInfo(this.state, this, renderTextContentObj[0])}</div>
        );
      case 1:
        // Billing is disabled for Plug platform
        if (PLATFORM === "plug") {
          return (
            <div style={{ padding: "40px", textAlign: "center" }}>
              <h2>Billing Not Available</h2>
              <p>Billing is not available on the Plug platform at this time.</p>
            </div>
          );
        }
        return (
          <RenderOrgBilling
            state={this.state}
            setOpenPrompt={this.setOpenPrompt}
            languageObj={renderTextContentObj[p]}
          />
        );
      case 2:
        return (
          <RenderOrgBalanceReports
            languageObj={renderTextContentObj[p]}
            currentPlan={this.state.organizationObj.currentPlan}
            redirectToOrgBilling={this.redirectToOrgBilling}
            subDomain={this.state.organizationObj.subDomain}
            language={this.props.language}
          />
        );
      case 3:
        return RenderOrgDocs(this.state, this, renderTextContentObj[p]);
      case 4:
        return RenderOrgPassword(this.state, this, renderTextContentObj[p]);
      case 5:
        return RenderOrgTerms(this.state, this, renderTextContentObj[p]);
      case 6: // Payment Methods (consolidated)
        return (
          <RenderPaymentMethods
            languageObj={languageObj}
            state={this.state}
            func={this}
          />
        );
      case 7: // Payment Page Customization
        return RenderPaymentPageCustomization(this.state, this, languageObj.PaymentPageCustomization);
      case 8: // Custom Domain
        return (
          <RenderCustomDomain
            language={this.props.language}
            languageObj={languageObj.CustomDomain}
            state={this.state}
            func={this}
            organizationObj={this.state.organizationObj}
          />
        );
      case 9: // Custom Input Fields
        return (
          <RenderCustomInputFields
            language={this.props.language}
            languageObj={languageObj.CustomFields}
            state={this.state}
            func={this}
          />
        );
      case 10: // Receipt Management
        return RenderOrgReceipt(this.state, this, languageObj.OrgReceipt);

      case 11: // Revenue Sharing (business only)
        return (
          <div>
            <RevenueShareConfig
              languageObj={languageObj.RevenueShareConfig || {}}
            />
            <NonprofitLinker
              languageObj={languageObj.NonprofitLinker || {}}
              defaultPercentage={(this.state.organizationObj && this.state.organizationObj.defaultDonationPercentage) || 1}
            />
          </div>
        );
      case 12: // Enable on Plug (nonprofit only)
        // Deep links (location.page) and the sidebar can both land here
        // before the organization has loaded. Rendering then would show a
        // withdrawn organization as listed.
        if (!this.orgLoaded()) return null;
        return (
          <CollaborationSettings
            organizationObj={this.state.organizationObj}
            language={this.props.language}
            languageObj={languageObj.Collaboration || {}}
            // Keep the page's copy of the org in step, so navigating away and
            // back does not show a stale listing state (CP-300).
            onListingChange={(optedIn) => {
              this.setState({
                organizationObj: {
                  ...this.state.organizationObj,
                  plugListingOptIn: optedIn,
                },
              });
            }}
          />
        );

      // Payment Method Individual Pages (100-111)
      case 100: // Stripe
        return (
          <PaymentMethodPage
            methodKey="stripe"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 101: // PayMe
        return (
          <PaymentMethodPage
            methodKey="payme"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 102: // PayPal
        return (
          <PaymentMethodPage
            methodKey="paypal"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 103: // Tap & Go
        return (
          <PaymentMethodPage
            methodKey="tapandgo"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 104: // Alipay
        return (
          <PaymentMethodPage
            methodKey="alipay"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 105: // WeChat Pay
        return (
          <PaymentMethodPage
            methodKey="wechatpay"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 106: // BoC Pay
        return (
          <PaymentMethodPage
            methodKey="bocpay"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 107: // Octopus
        return (
          <PaymentMethodPage
            methodKey="octopus"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 108: // FPS
        return (
          <PaymentMethodPage
            methodKey="fps"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 109: // Bank Transfer
        return (
          <PaymentMethodPage
            methodKey="bank_transfer"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 110: // Cheque
        return (
          <PaymentMethodPage
            methodKey="check_writing"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 111: // Cash
        return (
          <PaymentMethodPage
            methodKey="cash"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );
      case 112: // PayPal (Manual)
        return (
          <PaymentMethodPage
            methodKey="paypal_manual"
            state={this.state}
            func={this}
            languageObj={languageObj}
          />
        );

      default:
        return RenderOrgInfo(this.state, this, renderTextContentObj[0]);
    }
  }

  renderLeftSidebar() {
    const languageObj = this.props.languageObj;
    const names = languageObj.page;
    let btns = [];

    // Define general indices (Organization Info, Billing, Reports, Legal Documents, Change Password, T&C)
    // Hide Billing (index 1) for Plug platform
    const generalIndices = PLATFORM === "plug"
      ? [0, 2, 3, 4, 5]  // Exclude index 1 (Billing) for Plug
      : [0, 1, 2, 3, 4, 5];

    // Payment Methods is now a single consolidated page at index 6
    const paymentMethodIndex = 6;

    // Define customizability indices (Theme Color, Custom Domain, Custom Input Fields, Receipt Management)
    // Renumbered from 16-19 to 7-10
    const customizabilityIndices = [7, 8, 9, 10];

    // Define customizability names (since indices changed)
    const customizabilityNames = [
      languageObj.PaymentPageCustomization?.title || "Payment Page Customization",
      languageObj.CustomDomain?.title || "Custom Domain",
      languageObj.CustomFields?.title || "Custom Input Fields",
      languageObj.OrgReceipt?.title || "Receipt Management"
    ];

    // Get category headers from language object or use defaults
    const generalHeader = (languageObj.categories && languageObj.categories.general) || "General";
    const paymentMethodsHeader = (languageObj.categories && languageObj.categories.paymentMethods) || "Payment Methods";
    const customizabilityHeader = (languageObj.categories && languageObj.categories.customizability) || "Customizability";

    // Add General category header at the beginning
    btns.push(
      <div
        className={`OrgSettingsnestedItem OrgSettings-generalHeader ${this.state.generalExpanded ? "expanded" : ""}`}
        key="general-header"
        onClick={this.clickChangePage.bind(this, -2)}
      >
        <div className="OrgSettingsnestedtitle">
          {generalHeader}
        </div>
        <div className={`OrgSettingsnextBtn ${this.state.generalExpanded ? "expanded" : ""}`}></div>
      </div>
    );

    // Add general items if expanded
    if (this.state.generalExpanded) {
      generalIndices.forEach((index) => {
        btns.push(
          <div
            className={`OrgSettingsnestedItem OrgSettings-generalItem ${this.state.page === index ? 'selected' : ''}`}
            key={index}
            onClick={this.clickChangePage.bind(this, index)}
            style={{
              paddingLeft: "30px",
              height: "60px",
              borderTop: "1px solid #eaeaea",
              boxShadow: "none",
            }}
          >
            <div className="OrgSettingsnestedtitle">
              {names[index]}
            </div>
          </div>
        );
      });
    }

    // Payment method items configuration
    const paymentMethodItems = [
      { index: 100, name: 'Stripe' },
      { index: 101, name: 'PayMe' },
      { index: 102, name: 'PayPal' },
      { index: 103, name: 'Tap & Go' },
      { index: 104, name: 'Alipay' },
      { index: 105, name: 'WeChat Pay' },
      { index: 106, name: 'BoC Pay' },
      { index: 107, name: 'Octopus' },
      { index: 108, name: 'FPS' },
      { index: 109, name: 'Bank Transfer' },
      { index: 110, name: 'Cheque' },
      { index: 111, name: 'Cash' }
    ];

    // Add Payment Methods as expandable dropdown header
    btns.push(
      <div
        className={`OrgSettingsnestedItem OrgSettings-paymentMethodsHeader ${this.state.paymentMethodsExpanded ? 'expanded' : ''}`}
        key="payment-methods-header"
        onClick={this.clickChangePage.bind(this, -4)}
      >
        <div className="OrgSettingsnestedtitle">
          {paymentMethodsHeader}
        </div>
        <div className={`OrgSettingsnextBtn ${this.state.paymentMethodsExpanded ? 'expanded' : ''}`}></div>
      </div>
    );

    // Add payment method items if expanded
    if (this.state.paymentMethodsExpanded) {
      // Individual payment method items
      paymentMethodItems.forEach((method) => {
        const methodKey = {
          100: 'stripe', 101: 'payme', 102: 'paypal', 103: 'tapandgo',
          104: 'alipay', 105: 'wechatpay', 106: 'bocpay', 107: 'octopus',
          108: 'fps', 109: 'bank_transfer', 110: 'check_writing', 111: 'cash'
        }[method.index];

        btns.push(
          <div
            className={`OrgSettingsnestedItem OrgSettings-paymentMethodItem ${this.state.page === method.index ? 'selected' : ''}`}
            key={`payment-method-${method.index}`}
            onClick={this.clickChangePage.bind(this, method.index)}
            style={{
              paddingLeft: "30px",
              height: "60px",
              borderTop: "1px solid #eaeaea",
              boxShadow: "none",
            }}
          >
            <div className="OrgSettingsnestedtitle">
              {method.name}
            </div>
          </div>
        );
      });
    }

    // Add Customizability section
    btns.push(
      <div
        className={`OrgSettingsnestedItem OrgSettings-customizabilityHeader ${this.state.customizabilityExpanded ? "expanded" : ""}`}
        key="customizability-header"
        onClick={this.clickChangePage.bind(this, -3)}
      >
        <div className="OrgSettingsnestedtitle">
          {customizabilityHeader}
        </div>
        <div className={`OrgSettingsnextBtn ${this.state.customizabilityExpanded ? "expanded" : ""}`}></div>
      </div>
    );

    // Add customizability items if expanded
    if (this.state.customizabilityExpanded) {
      customizabilityIndices.forEach((index, i) => {
        btns.push(
          <div
            className={`OrgSettingsnestedItem OrgSettings-customizabilityItem ${this.state.page === index ? 'selected' : ''}`}
            key={index}
            onClick={this.clickChangePage.bind(this, index)}
            style={{
              paddingLeft: "30px",
              height: "60px",
              borderTop: "1px solid #eaeaea",
              boxShadow: "none",
            }}
          >
            <div className="OrgSettingsnestedtitle">
              {customizabilityNames[i]}
            </div>
          </div>
        );
      });
    }

    // Get organization type for Revenue Sharing / Collaboration.
    // A missing organizationType means nonprofit, matching the schema default
    // and CollaborationSettings. Requiring an explicit value here would have
    // hidden the Plug withdrawal switch from any organization whose type was
    // never set, leaving it listed with no way out (CP-300).
    // Gate on orgLoaded() rather than on organizationObj alone: until the
    // fetch lands it is [], which is truthy, so every organization —
    // businesses included — would be shown the nonprofit-only item.
    const orgType = this.state.organizationObj?.organizationType;
    const isBusiness = orgType === 'business';
    const isNonprofit = this.orgLoaded() && !isBusiness;

    // Add Revenue Sharing (business only)
    if (isBusiness) {
      btns.push(
        <div
          className={`OrgSettingsnestedItem OrgSettings-revenueShareItem ${this.state.page === 11 ? 'selected' : ''}`}
          key={11}
          onClick={this.clickChangePage.bind(this, 11)}
        >
          <div className="OrgSettingsnestedtitle">
            {languageObj.RevenueShare?.title || "Revenue Sharing"}
          </div>
          <div className="OrgSettingsnextBtn"></div>
        </div>
      );
    }

    // Enable on Plug (nonprofit only) — the organization's own marketplace
    // switch. The locale key stays `Collaboration` so the page keeps its
    // existing translations.
    if (isNonprofit) {
      btns.push(
        <div
          className={`OrgSettingsnestedItem OrgSettings-plugListingItem ${this.state.page === 12 ? 'selected' : ''}`}
          key={12}
          onClick={this.clickChangePage.bind(this, 12)}
        >
          <div className="OrgSettingsnestedtitle">
            {languageObj.Collaboration?.title || "Enable on Plug"}
          </div>
          <div className="OrgSettingsnextBtn"></div>
        </div>
      );
    }

    return btns;
  }

  render() {

    return (
      <div className="OrgSettings-view" data-testid="orgsettings-view">
        <div className="OrgSettings-headerContainer">
          <div
            className={
              PLATFORM === "plug"
                ? "OrgSettings-PlugLogo"
                : "OrgSettings-CheckPlusLogo"
            }
            onClick={this.onBackBtn}
          />
          {/* Mobile-specific navigation */}
          <div className="OrgSettings-mobileNav">
            <div
              className={`OrgSettings-menuContainer ${this.state.mobileMenuExpanded ? 'active' : ''}`}
              onClick={this.toggleMobileMenu}
            >
              <div className="OrgSettings-menuIcnContainer">
                <div className="OrgSettings-menuIcon">
                  <div></div>
                </div>
              </div>
            </div>

            <div
              className={
                PLATFORM === "plug"
                  ? "OrgSettings-PlugLogo"
                  : "OrgSettings-CheckPlusLogo"
              }
              onClick={this.onBackBtn}
            />

            <div className="OrgSettings-languageSelector">
              <div className="OrgSettings-globe"></div>
              {renderOrgLanguageSelector()}
            </div>
          </div>

          {/* Desktop navigation */}
          <div className="OrgSettings-navBarContainer">
            <div className="OrgSettings-homeContainer" onClick={this.onBackBtn}>
              <div className="OrgSettings-homeIcnContainer">
                <div className="OrgSettings-homeIcn"></div>
              </div>
            </div>

            <div
              className="OrgSettings-settingsContainer"
              onClick={this.orgSettingsBtn}
            >
              <div className="OrgSettings-settingsIcnContainer">
                <div className="OrgSettings-settingsIcon" />
              </div>
            </div>

            <a
              href="https://intercom.help/checkplus/en"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="OrgSettings-faqContainer">
                <div className="OrgSettings-faqIcnContainer">
                  <div className="OrgSettings-faqIcon" />
                </div>
              </div>
            </a>

            <div
              className="OrgSettings-logoutContainer"
              onClick={() => {
                this.props.orgLogout();
              }}
            >
              <div className="OrgSettings-logoutIcnContainer">
                <div className="OrgSettings-logoutIcon" />
              </div>
            </div>

            <div className="OrgSettings-languageSelector">
              <div className="OrgSettings-globe"></div>
              {renderOrgLanguageSelector()}
            </div>
          </div>
        </div>

        <div className="OrgSettings-view2">


          <div className={`OrgSettings-leftSidebar ${this.state.mobileMenuExpanded ? '' : 'collapsed'}`}>
            {/* Mobile navigation in sidebar */}
            <div className="OrgSettings-mobileNavMenu">
              <div className="OrgSettings-navItems">
                <div className="OrgSettings-homeContainer" onClick={this.onBackBtn}>
                  <div className="OrgSettings-homeIcnContainer">
                    <div className="OrgSettings-homeIcn"></div>
                  </div>
                </div>

                <div
                  className="OrgSettings-settingsContainer"
                  onClick={this.orgSettingsBtn}
                >
                  <div className="OrgSettings-settingsIcnContainer">
                    <div className="OrgSettings-settingsIcon" />
                  </div>
                </div>

                <a
                  href="https://intercom.help/checkplus/en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="OrgSettings-faqContainer">
                    <div className="OrgSettings-faqIcnContainer">
                      <div className="OrgSettings-faqIcon" />
                    </div>
                  </div>
                </a>

                <div
                  className="OrgSettings-logoutContainer"
                  onClick={() => {
                    this.props.orgLogout();
                  }}
                >
                  <div className="OrgSettings-logoutIcnContainer">
                    <div className="OrgSettings-logoutIcon" />
                  </div>
                </div>
              </div>
            </div>

            {/* Settings sidebar menu */}
            {this.renderLeftSidebar()}
          </div>
        </div>

        <div className="OrgSettings-view3">{this.renderSettingContent()}</div>
      </div>
    );
  }
}

OrgSettings.propTypes = {
  orgLogout: PropTypes.func,
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default OrgSettings;
